<template>
  <div class="home">

    <div class="home_bottom">
      <div class="home_bottom_container">
        <div class="bottom_center">
          <div>
            <img src="../assets/images/home_company_top.png">
          </div>
          <div>杭州富从智能技术有限公司</div>
        </div>
        <div class="bottom_center">
          <div>咨询热线</div>
          <div>--------</div>
          <div>13376821181</div>
        </div>
        <div class="bottom_center">
          <div class="toUrlCls" @click="goPage"> 浙ICP备13004239号-1</div>
          <div>--------</div>
          <div>©2017 杭州富从智能技术有限公司 版权所有</div>
        </div>
        <div class="bottom_center">
          <div>合作邮箱</div>
          <div>--------</div>
          <div>342029782@qq.com</div>
        </div>
        <div class="bottom_center">
          <div>联系地址</div>
          <div>--------</div>
          <div>杭州市拱墅区新文路33号天堂e谷4号楼220室</div>
        </div>
        <div class="bottom_center">
          <div class="toUrlCls" @click="goMap">网站地图</div>
          <div>--------</div>
          <div>网站地图</div>
        </div>
      </div>
    </div>
    <div style="width:300px;margin:0 auto; padding:20px 0;">
      <a target="_blank" href="https://beian.miit.gov.cn" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img src="../assets/images/layout_bottom_zf.png" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#ffffff;">
          浙ICP备13004239号</p></a>

    </div>
  </div>

</template>

<script>

export default {
  data() {
    return {};
  },
  created() {
  },
  mounted() {
  },
  computed: {},
  methods: {
    goPage: function () {
      // window.location.href =
      window.open("http://beian.miit.gov.cn/");
    },
    goMap: function () {
      // window.location.href =
      window.open("http://www.fc-zn.com/sitemap.xml");
    },
  }
};
</script>

<style lang="less" scoped>

.home {
  background: url("../assets/images/home_bottom_back.png");

  .home_bottom {
    display: flex;
    height: 150px;

    .home_bottom_container {
      display: flex;
      color: #ffffff;
      width: 100%;
      margin: 20px 0;

      .bottom_center {
        flex: 1;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        font-size: 14px;

        .toUrlCls {
          cursor: pointer;
        }

      }

    }

  }

}


</style>
